<template #default>
    <div class="content-wrapper">
        <div class="content-block dx-card responsive-paddings">
            <DxForm id="form1" :form-data="incorporationData">
                <DxGroupItem :caption="$t('manageAccount.manageAccounts')" :col-count="1">
                    <DxSimpleItem name="ManageAccountLinesGrid_">
                        <template #default>
                            <DxDataGrid id="ManageAccountLinesGrid"
                                        :show-borders="true"
                                        :row-alternation-enabled="true"
                                        :hover-state-enabled="true"
                                         @row-inserted="onSave($event)"
                                         @row-removed="onRemove($event)"
                                        :data-source="ManageAccountData"
                                        ref="dataGridRefKey"
                                        key-expr="Id">
                                <DxColumn
                                    data-field="No"
                                    :caption="$t('manageAccount.no')"
                                    :allow-editing="false">
                                </DxColumn>

                                <DxColumn data-field="Login_Name"
                                    :editor-options="{ mask: '+242 000 000 000' }"
                                    :caption="$t('manageAccount.loginName')">
                                <DxRequiredRule />
                                </DxColumn>

                                 <DxColumn
                                     :caption="$t('manageAccount.role')"
                                     data-field="User_Position_Id">
                                     <DxFormItem/>
                                     <DxLookup
                                         :data-source="RoleOptions"
                                         value-expr="Id"
                                         display-expr="Name"/>
                                 </DxColumn>

                                <DxColumn
                                    caption="Password"
                                    :visible="false"
                                    data-field="Password" :editor-options="{ mode: 'password' }">
                                    <DxRequiredRule />
                                </DxColumn>

                                <DxColumn data-field="Created_At" format="dd-MM-yyyy" data-type="date"
                                    :allow-editing="false" :caption="$t('manageAccount.createdAt')">
                                </DxColumn>

                                <DxEditing mode="form" :allow-deleting="true" :allow-adding="true" />

                                <DxColumnFixing :enabled="true" />

                                <DxGroupPanel :visible="true" />

                                <DxExport :enabled="true"
                                          :formats="['pdf']"
                                          :allow-export-selected-data="true" />

                                <DxSearchPanel location="before"
                                               :visible="true"
                                               :highlight-case-sensitive="true" />
                                <DxPager :show-page-size-selector="true" />
                                <DxPaging :page-size="10" />
                            </DxDataGrid>
                        </template>
                    </DxSimpleItem>
                </DxGroupItem>
            </DxForm>
        </div>
    </div>
</template>

<script>
    import DxForm, {
        DxGroupItem,
        DxSimpleItem,
        DxButtonItem,
        DxLabel,
        DxRequiredRule,
        DxCompareRule,
        DxRangeRule,
        DxStringLengthRule,
        DxPatternRule,
        DxEmailRule,
        DxAsyncRule,
    } from 'devextreme-vue/form'
    import DxItemPanel from "devextreme-vue/tab-panel"
    import DxAutocomplete from 'devextreme-vue/autocomplete'
    import {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxToolbar,
        DxItem,
        DxFormItem,
        DxLookup,
        DxExport,
        DxSelection,
        DxGrouping,
        DxPager,
        DxPaging,
        DxSearchPanel,
        DxLoadPanel,
        DxMasterDetail,
        DxColumnFixing,
        DxGroupPanel,
    } from 'devextreme-vue/data-grid'

    import DxRadioGroup from 'devextreme-vue/radio-group'

    import DxButton from 'devextreme-vue/button'

    import notify from 'devextreme/ui/notify'

    import dateUtil from '@/helpers/dateUtil'

    import { jsPDF } from 'jspdf'
    import 'jspdf-autotable'
    import { exportDataGrid } from 'devextreme/pdf_exporter'
    import { Workbook } from 'exceljs'
    import { saveAs } from 'file-saver-es'

    import { mapState, mapActions } from 'vuex'
    import { GET_USERS, POST_ADD_USER } from '@/store/_actiontypes'

    const dataGridRefKey = "my-data-grid"

    export default {
        components: {
            DxGroupItem,
            DxSimpleItem,
            DxButtonItem,
            DxButton,
            DxRadioGroup,
            DxLabel,
            DxItemPanel,
            DxItem,
            DxDataGrid,
            DxColumn,
            DxEditing,
            DxFormItem,
            DxLookup,
            DxExport,
            DxSelection,
            DxPager,
            DxPaging,
            DxSearchPanel,
            DxMasterDetail,
            DxGrouping,
            DxLoadPanel,
            DxToolbar,
            DxItem,
            DxColumnFixing,
            DxGroupPanel,
            DxRequiredRule,
            DxCompareRule,
            DxPatternRule,
            DxRangeRule,
            DxEmailRule,
            DxStringLengthRule,
            DxForm,
            DxAutocomplete,
            DxAsyncRule,
            notify,
        },

        data() {
            const incorporationData = {}
            const status = [
                {
                    Id: true,
                    Name: 'Active'
                },
                {
                    Id: false,
                    Name: 'Inactive'
                }
            ]

            const role = [
                {
                    Id: 1,
                    Name: 'Admin'
                },
                {
                    Id: 2,
                    Name: 'App User'
                }
            ]

            return {
                RoleOptions: role,
                FacilityOptions: status,
                ProductOptions: status,
                dataOperation: ['New', 'Update'],
                selectedTabIndex: 0,
                isOrderVisible: true,
                dataGridRefKey,
                metaData: {},
                ManageAccountData: [],

                PrintColor: { 'color': '#6caddf', 'text-decoration': 'underline' },

                buttonOptions: {
                    text: 'Save Changes',
                    type: 'default',
                },
                incorporationData
            }
        },

        computed: {
            dataGrid: function () {
                return this.$refs.dataGridRefKey.instance
            }
        },

        mounted() {
            this.loadData()
        },

        methods: {
            ...mapActions("user", [
                GET_USERS
            ]),

            ...mapActions("application", [
                POST_ADD_USER
            ]),

            loadData() {
                this.GET_USERS().then(res => {
                    this.bindData(res.data)      
                })
                .catch(error => {
                    console.log(error)
                })
            },

            bindData(data) {
                this.ManageAccountData = data.map((item, index) => {
                    return {
                        No: index+1,
                        Id: item.user_Id,
                        Login_Name: item.login_Name,
                        Department_Id: item.department_Id,
                        User_Position_Id: 1,//item.user_Position_Id,
                        Is_Relevant: item.is_Relevant,
                        Is_Relevant: item.is_Relevant,
                        Created_At: item.created_At
                    }
                })
            },

            onSave(event) {
                let payload = event.data
                this.POST_ADD_USER(payload).then(res => {
                    this.ManageAccountData = []
                    this.loadData()
                    this.$toast.success("User added successfully!")
                })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("Something went wrong. Try again")
                })
            },
            
            onRemove(event) {
                let payload = event.data
                payload.IsRelevant = false
                payload._Id = event.data.Id
                this.POST_ADD_USER(payload).then(res => {
                    this.GridDataSource = []
                    this.loadData()
                    this.$toast.success("User removed successfully")
                })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("Something went wrong. Try again")
                })
            },

        }
    }
</script>